/**
 * @(#)SoftKey.js 1.0 2017/9/20.
 * @author
 * Copyright (c) 2017, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import Tag from "./Tag";
import Img from "./Img";
import Icon from "./Icon";
import Time from "./Time/index";
import String from "./String/index";
import Number from "./Number/index";
import Status from "./Status";
import Progress from "./Progress";

export default {
  Tag,
  Img,
  Icon,
  Time,
  String,
  Number,
  Status,
  Progress,
};



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/index.js